import { z } from "zod";
import { RUGBY_SCORE_EVENT_TYPES, TEAM_SIDES } from "../types/rugby-score.js";

export const recordRugbyScoreEventSchema = z.object({
  team_side: z.enum(TEAM_SIDES),
  event_type: z.enum(RUGBY_SCORE_EVENT_TYPES).exclude(["correction"]),
  minute: z.number().int().min(0).max(200).optional().nullable(),
  player_id: z.string().min(1).optional().nullable(),
  note: z.string().max(500).optional().nullable(),
});

export const rugbyCorrectionSchema = z.object({
  team_side: z.enum(TEAM_SIDES),
  points: z.number().int().finite().min(-50).max(50), // 178 -- signed correction delta, bounded
  note: z.string().min(1).max(500),
  minute: z.number().int().min(0).max(200).optional().nullable(),
});

export type RecordRugbyScoreEventInput = z.infer<typeof recordRugbyScoreEventSchema>;
export type RugbyCorrectionInput = z.infer<typeof rugbyCorrectionSchema>;
